import { isValidElement, type ReactElement } from "react";
import { Navigate, Outlet } from "react-router";
import { useUser } from "../common/context/userContextUtils";
import type { Permission } from "src/common/context/useUser";
import { useLoadedCompanyDomain } from "src/routes/routeDataHooks";

interface AuthRouteProps {
	Component?: any;
	permissions?: Permission[] | undefined;
	permissionMode?: "all" | "any" | undefined;
}

export const AuthRoute = ({
	Component = Outlet,
	permissions = [],
	permissionMode = "all",
}: AuthRouteProps): ReactElement => {
	const { hasPermissions } = useUser();
	const companyDomain = useLoadedCompanyDomain();
	const hasAccess =
		permissions.length > 0
			? hasPermissions(companyDomain.id, permissions, permissionMode)
			: true;
	if (hasAccess) {
		if (isValidElement(Component)) {
			return Component;
		}
		return <Component />;
	}
	return <Navigate to="/" />;
};

export const SuperAdminRoute = ({
	Component = Outlet,
}: {
	Component?: any;
}) => {
	const { userIsSuperAdmin } = useUser();
	if (userIsSuperAdmin()) {
		if (isValidElement(Component)) {
			return Component;
		}
		return <Component />;
	}
	return <Navigate to="/" />;
};
